import { useQuery } from "react-query";
import { UPLOAD_CUSTOMER_DOCUMENT } from "../../../../api/ajax-endpoints";
import { getData } from "../../../../newApis/dotNetApiMethods";

type TQuery = {
  customerId?: number;
};

export const useGetCustomerDocumentsForAdmin = ({ customerId }: TQuery) => {
  return useQuery(
    [{ customerId }, "getCustomerDocumentsForAdmin"],
    async () => {
      const data = await getData(
        `${UPLOAD_CUSTOMER_DOCUMENT}?sourceAppId=5&funderId=${customerId}`,
      );
      return data?.data || [];
    },
    {
      enabled: !!customerId,
    },
  );
};
